import { render, staticRenderFns } from "./ApiLogsTable.vue?vue&type=template&id=edffee98&"
import script from "./ApiLogsTable.vue?vue&type=script&lang=js&"
export * from "./ApiLogsTable.vue?vue&type=script&lang=js&"
import style0 from "./ApiLogsTable.vue?vue&type=style&index=0&id=edffee98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports